import { ReducedPageType } from '../types/servicesTypes/pageTypes'

type ReducedPageKeys = keyof ReducedPageType

export const reducedPageKeys: ReadonlyArray<ReducedPageKeys> = [
  'id',
  'icon',
  'name',
  'title',
  'shortTitle',
  'previewImage',
] as const
